import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const FullscreenLoader = () => (
  <div className="min-h-screen bg-background flex items-center justify-center">
    <div className="text-xs uppercase tracking-[0.3em] text-foreground/60 animate-pulse">
      Carregando…
    </div>
  </div>
);

export const ProtectedRoute = ({ children, roles }) => {
  const location = useLocation();
  const { loading, user } = useAuth();
  if (loading) return <FullscreenLoader />;
  if (!user) return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  if (roles && !roles.includes(user.role)) {
    return <Navigate to="/" replace />;
  }
  return children;
};
